<template>
  <b-card-code title="User Logs">
    
    <b-card-code class="bg-light-secondary mb-1" title="Search">
      <b-form inline style="display: inline-block; width: 100%">
        <div class="row" style="width: 100%; padding: 5px">
          <b-form-select
            class="ml-1"
            v-if="is_staff"
            @change="loadOrgUsers"
            v-model="organization"
            style="width: 40%"
            :options="organizations"
          >
          </b-form-select>

          <b-form-select
            class="ml-1"
            v-if="is_staff"
            @change="searchFn"
            v-model="user"
            style="width: 40%"
            :options="users"
          >
          </b-form-select>
         
        </div>
      </b-form>
    </b-card-code>
    <div class="d-flex justify-content-center mb-1" v-if="loading">
      <b-spinner class="float-right" label="Floated Right" />
    </div>
    
    <b-table
      responsive
      id="LogTable"
      :fields="fields"
      :items="items"
      :per-page="perPage"
      ref="table"
      v-if="!loading"
      hover
    >
      <template #cell(index)="data">
        {{ data.index + 1 + perPage * (currentPage - 1) }}
      </template>
      <template #cell(log_message)="data">
      <p v-html="data.item.log_message"></p> 
      </template>

      <template #cell(activity_time)="data">
        <span >{{ new Date(data.item.activity_time).toLocaleString() }}</span>
      </template>
    </b-table>

    <b-pagination-nav
      v-model="currentPage"
      :numberOfPages="total"
      :total-rows="rows"
      :link-gen="linkGen"
      :per-page="perPage"
      :align="pagination_pos"
      aria-controls="LogTable"
      use-router
      v-if="!loading"
    />

  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { BTable } from "bootstrap-vue";
import {
  BPagination,
  BPaginationNav,
  BButton,
  BBadge,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BForm,
  BFormInput,
  BFormSelect,
  BSpinner
} from "bootstrap-vue";

export default {
  components: {
    BCardCode,
    BTable,
    BPagination,
    BPaginationNav,
    BButton,
    BBadge,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BForm,
    BFormInput,
    BFormSelect,
    BSpinner
  },
  data() {
    return {
      pagination_pos: "center",
      is_staff: this.$store.state.app.user.is_staff,
      organization: null,
      organizations: [{ value: null, text: "--Select Organization--" }],
      user: null,
      users: [{ value: null, text: "--Select User--" }],
      items: [],
      currentPage: 1,
      perPage: 10,
      rows:0,
      total: 1,
      is_search_on: false,
      loading: false,
      fields: [
        { key: 'index', label: '#' },
        { key: 'log_message', label: 'Log Message' },
        { key: 'activity_on', label: 'Activity on' },
        { key: 'ref_id', label: 'Ref ID' },
        { key: 'activity_time', label: 'Activity Time' },
      ],
    };
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      this.searchFn(false);
    },
  },

  created: function () {
    this.loadOrg();
  },

  methods: {
    linkGen: function (pageNum) {
      return this.$router.currentRoute.path + "?page=" + pageNum;
    },
    loadOrg: function () {
      if (this.$route.query.page) this.currentPage = this.$route.query.page;
      this.loading = true;
      this.organizations = [
        { value: null, text: "--Select Organization--" },
        { value: "system", text: "Secusy System" },
      ];

      if (this.is_staff) {
        this.loading = true;
        // Load oragnization drop down
        const o_options = {
          method: "GET",
          headers: { "content-type": "application/json" },
          url: process.env.VUE_APP_BASEURL + "organization/organization/",
        };
        var self = this;
        this.$http(o_options).then((res) => {
          // console.log(res.data)
          res.data.map(function (value, key) {
            let org = {
              value: res.data[key].org_id,
              text: res.data[key].org_name,
            };
            // console.log(res.data[key].profile.organization)
            self.organizations.push(org);
          });
          this.loading = false;
        });
      } else {
        this.organization = this.$store.state.app.user.profile.organization;
        this.searchFn();
      }
    },
    loadOrgUsers: function () {
      this.users =  [{ value: null, text: "--Select User--" }]
      this.loading = true;
      // Load User drop down
      let url =
        process.env.VUE_APP_BASEURL +
       "user/users?query=true";
        
      if (this.organization != null) {
        if (this.organization == "system") {
          url = url + "&role_type=" + 0;
        }else{
          url = url + "&q_org_id=" + this.organization;
        }
      }
      const o_options = {
        method: "GET",
        headers: { "content-type": "application/json" },
        url: url,
      };
      var self = this;

      this.$http(o_options).then((res) => {
        res.data.map(function (value, key) {
          let user = {
            value: res.data[key].id,
            text: res.data[key].first_name,
          };
          self.users.push(user);
        });
        this.loading = false;
      });
    },
    
    searchFn: function (reset = true) {
      this.is_search_on = false;
      this.loading = true;
      this.filter = [];
      if (reset) this.currentPage = 1;
      let url =
        process.env.VUE_APP_BASEURL +
        "logs/v1/logs/user-logs?query=true" +
        "&page=" +
        this.currentPage;
      
      if (this.user != null) {
        this.filter.push({ user: this.user });
        url = url + "&user_id=" + this.user;
      }

      if (this.filter.length) this.is_search_on = true;
      const options = {
        method: "GET",
        headers: { "content-type": "application/json" },
        url: url,
      };
      this.$http(options).then((res) => {
        this.items = res.data.results;
        this.rows = res.data.length;
        this.total = Math.ceil(res.data.count / this.perPage);
        this.loading = false;
      });
    },
  },
};
</script>